import React, { useEffect, useRef } from "react";//useState,
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { 
  Button, 
  DialogContent,
  DialogActions,
  IconButton,
  Dialog,
  DialogTitle,
  

} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";  
import { useQuery, useMutation } from "@tanstack/react-query";
import * as api from "../../../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator } from "react-tabulator";
import { useTranslation } from "react-i18next";



import { format } from 'date-fns';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          className="float-end"
          size="large">
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const OrderModal =({ handleClose, openOrder, addOrder, ItemGroupId, ...props }) => {
  const { t } = useTranslation();
//console.log('props== ',ItemGroupId);
  //get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const FacilityId=localStorage.getItem('FacilityId');
const lan = localStorage.getItem('LangCode');
const menukey = "issue";
 
  const tblOrderRefHolder = useRef({ table: null });
  const tblOrderRef = tblOrderRefHolder.current;

  let params = {
    //action: 'getProducts',
    menukey: menukey,
    ItemGroupId: ItemGroupId,
    FacilityId: FacilityId,
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
  };

  const { isLoading, error, isError, data, refetch } = useQuery(
    [params],
    api.getNonIssuedReceivedOrderList
  );

  
/*   const { data } = useQuery(["NonReceive"],
    api.getNonReceivedOrderList
  ); */
   
  const OrderModalColumns = [
    { title: "id", field: "id", visible: false }, 
    { title: t(DispensingLanguage[lan][menukey]['Sl#']),  formatter: "rownum", width:50, hozAlign: "center",
     headerHozAlign:"center", headerSort:false },
    { title: t(DispensingLanguage[lan][menukey]['Order No']), field: "OrderNo",  width: 300 },
    { title: t(DispensingLanguage[lan][menukey]['Order Date']), field: "OrderDate", width: 100, 
      formatter: function (cell, formatterParams) {
      let value = cell.getValue();
       
      return (value==null?'':format(new Date(value), 'dd/MM/yyyy'));
      
    } },
    { title: t(DispensingLanguage[lan][menukey]['Order Type']), field: "OrderType" , width: 100 },
    { title: t(DispensingLanguage[lan][menukey]['Order From']), field: "OrderFrom" },
  ]; 
  const OrderModaltDataItems = data?.map((item, index) => { 
    return item;
  });
  const {mutate} = useMutation(api.saveNonIssuedOrder, {
    onSuccess: (data)=>{
       
      addOrder(data);
      //queryClient.getQueriesData('receive');
    }
  })
  const SaveSelectedOrder = () => { 

    if(tblOrderRef.table.getSelectedData().length>0)
    mutate(tblOrderRef.table.getSelectedData()[0].OrderId); 
   
  };

  
useEffect(() => {

}, []);

  return (
    <div>
     
      <BootstrapDialog
        onClose={() => handleClose('OrderModal')}
        aria-labelledby="customized-dialog-title"
        open={openOrder}
        fullWidth={true}
        maxWidth="md"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => handleClose('OrderModal')}
        >
         {DispensingLanguage[lan][menukey]['Order Lists']}
        </BootstrapDialogTitle>
        <DialogContent dividers>  
          <ReactTabulator onRef={(r) => { tblOrderRef.table = r.current; }}
           options={{
             selectableRowsRangeMode: 'click',
             selectableRows: 1,
           }}
           columns={OrderModalColumns}
           data={OrderModaltDataItems}
           height="300px" 
          />
        </DialogContent>
        <DialogActions>
          <Button 
          className="me-2 float-start"
          variant="contained"
          color="primary" 
          onClick={SaveSelectedOrder}>
           {DispensingLanguage[lan][menukey]['ADD']} 
          </Button>
          <Button autoFocus 
          className="float-start"
          variant="contained"
          color="gray"
          onClick={() => handleClose('OrderModal')}>
            {DispensingLanguage[lan][menukey]['CANCEL']} 
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default OrderModal;
